import api from '@/api/userManagement'

const state = {

}

const actions = {
  getUserList (context, params) {
    return api.getUserList(params)
  },
  exportUserList (context, params) {
    return api.exportUserList(params)
  },
  updateUser (context, userData) {
    return api.updateUser(userData)
  },
  getUser (context, params) {
    return api.getUser(params)
  },
  saveUser (context, userData) {
    return api.saveUser(userData)
  },
  resetPassword (context, params) {
    return api.resetPassword(params)
  },
  userEmailValidate (context, userData) {
    return api.userEmailValidate(userData)
  },
  userMobileValidate (context, userData) {
    return api.userMobileValidate(userData)
  },
  getRole (context, params) {
    return api.getRole(params)
  },
  updateRole (context, data) {
    return api.updateRole(data)
  },
  getUserDefaultInfo () {
    return api.getUserDefaultInfo()
  },
  resetPasswordByHR (context, { accountId, userData }) {
    return api.resetPasswordByHR(accountId, userData)
  },
  getResetPasswordPermission (context, { accountId, params }) {
    return api.getResetPasswordPermission(accountId, params)
  },
  getCancellationAccountByEmailOrMobile (context, params) {
    return api.getCancellationAccountByEmailOrMobile(params)
  },
  deleteAccount (context, params) {
    return api.deleteAccount(params)
  },
  createServiceAccount (context, params) {
    return api.createServiceAccount(params)
  },
  checkPasswordExistence (context, params) {
    return api.checkPasswordExistence(params)
  },
  updatePasswordByUser (context, params) {
    return api.updatePasswordByUser(params)
  }
}

const mutations = {

}

const getters = {

}
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
